<div class="main-content">
  <dx-load-panel
    [visible]="isLoading"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    shadingColor="rgba(0,0,0,0.4)">
  </dx-load-panel>

  <form #formElement (submit)="onSubmit($event)">
    <dx-form data-testid="payoff-paydown-form"
      [formData]="payoffPaydownData"
      [colCount]="formColCount"
      [items]="formItems"
      labelLocation="top"
      validationGroup="formGroup"
      (onContentReady)="onFormContentReady($event)"
      (onFieldDataChanged)="onFieldDataChanged($event)">
      <dxi-item
          [colSpan]="formColCount"
          labelMode="static"
          dataField="requestType"
          editorType="dxSelectBox"
          cssClass="dx-widget"
          [editorOptions]="{
            items: requestTypes,
            valueExpr: 'name',
            displayExpr: 'name',
            required: 'true' ,
            searchMode: 'contains',
            searchEnabled: true,
            onSelectionChanged: onRequestTypeSelectionChanged,
            onOpened: onRequestTypeDropdownOpened,
            disabled: isEditable
          }">
          <dxo-label text="Request Type"> </dxo-label>
          <dxi-validation-rule type="required" message="Request Type is required">
          </dxi-validation-rule>
        </dxi-item>
      <div *dxTemplate="let formItemData of 'loanAmountsGridTemplate'">
        <app-loan-amounts-grid
          [loanAmounts]="payoffPaydownData.loanNumbers"
          [loanData]="allLoanNumbers"
          [showInactiveLoans]="showInactiveLoans"
          [showAmountColumn]="false"
          [shouldDisableCheckbox]="shouldDisableCheckbox"
          [activeLoanCheckboxText]="activeLoanCheckboxText"
          [isGridInEditMode]="isGridInEditMode"
          [loanItemTemplate]="loanItemTemplate"
          (showInactiveLoansChange)="onGridShowInactiveLoansChange($event)"
          (gridEditModeChange)="onGridEditModeChange($event)"
          (loanAmountsChange)="onGridLoanAmountsChange($event)">
        </app-loan-amounts-grid>
      </div>
      <div *dxTemplate="let section of 'fileUploadTemplate'">
        <app-file-upload
          data-testid="payoff-paydown-request-file-upload"
          labelText=""
          selectButtonText="Browse or drop files here"
          [existingFileUrls]="isEditable ? (task?.parentUrls ?? []) : []"
          (onFileUploadEventEmitter)="onFileUpload($event)"
          (onFileRemoveEventEmitter)="onFileRemove($event)"
        >
        </app-file-upload>
      </div>
    </dx-form>
    <dx-load-panel data-testid="treasury-request-load-panel" container=".cards-wide" [position]="{ of: '.content' }" [visible]="isLoading" [showPane]="true"></dx-load-panel>
  </form>
</div>


